import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { Navbar, Footer, Sidebar, ThemeSettings } from './components';
import { Ecommerce, Orders, Calendar, Employees, Stacked, Pyramid, Customers, Kanban, Line, Area, Bar, Pie, Financial, ColorPicker, ColorMapping, Editor } from './pages';
import DataExploratoryAnalysis from './pages/DataExploratoryAnalysis';
import AImodeling from './pages/AImodeling';
import AIresult from './pages/AIresult';
import AIresultTotalDetail from './pages/AIresultTotalDetail';

import DataPreprocess from './pages/DataPreprocess';

import VisualizeWordcloud from './pages/VisualizeWordcloud';
import VisualizeWordcloudDetail from './pages/VisualizeWordcloudDetail';

import VisualizeWordFrequency from './pages/VisualizeWordFrequency';
import VisualizeWordFrequencyDetail from './pages/VisualizeWordFrequencyDetail';

import VisualizeWordnetwork from './pages/VisualizeWordnetwork';
import VisualizeWordnetworkDetail from './pages/VisualizeWordnetworkDetail';
import VisualizeWordcloudEdit from './pages/VisualizeWordcloudEdit';

import S3FileRequest from './pages/S3FileRequest';

import NoticeTestInfo from './pages/NoticeTestInfo';

import './App.css';
import ScrollToTop from './components/ScrollToTop'; // 생성한 ScrollToTop 컴포넌트 임포트

import { useStateContext } from './contexts/ContextProvider';

const App = () => {
  const { setCurrentColor, setCurrentMode, currentMode, activeMenu, currentColor, themeSettings, setThemeSettings } = useStateContext();

  // const [stopwords, setStopwords] = useState([]); // stopwords 상태 관리
  // const [nnp, setNnp] = useState([]); // stopwords 상태 관리

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <BrowserRouter>
        <div className="flex relative dark:bg-main-dark-bg">
          {/* <div className="fixed right-4 bottom-4" style={{ zIndex: '1000' }}>
            <TooltipComponent
              content="Settings"
              position="Top"
            >
              <button
                type="button"
                onClick={() => setThemeSettings(true)}
                style={{ background: currentColor, borderRadius: '50%' }}
                className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
              >
                <FiSettings />
              </button>

            </TooltipComponent>
          </div> */}
          {activeMenu ? (
            <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
              <Sidebar />
            </div>
          ) : (
            <div className="w-0 dark:bg-secondary-dark-bg">
              <Sidebar />
            </div>
          )}
          <div
            className={
              activeMenu
                ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
                : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
            }
          >
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
              <Navbar />
            </div>
            <div>
              {themeSettings && (<ThemeSettings />)}
              <ScrollToTop /> {/* 페이지 전환 시마다 스크롤을 최상단으로 이동 */}
              <Routes>

                {/* 랜딩페이지(테스트 안내 페이지) */}
                <Route path="/" element={(<NoticeTestInfo />)} />

                {/* 데이터 미리보가 */}
                <Route path="/eda" element={(<DataExploratoryAnalysis />)} />

                {/* AI 감정분류 */}
                <Route path="/cls/sentiment/modeling" element={(<AImodeling />)} />
                <Route path="/cls/sentiment/result" element={(<AIresult />)} />

                {/* AI 의도분류 */}
                <Route path="/cls/intent/modeling" element={(<AImodeling />)} />
                <Route path="/cls/intent/result" element={(<AIresult />)} />

                {/* AI 감정X의도분류 */}
                <Route path="/cls/total/result" element={(<AIresult />)} />
                <Route path="/cls/total/result-detail" element={(<AIresultTotalDetail />)} />

                {/* 데이터시각화 */}
                <Route path="/vis/preprocess" element={(<DataPreprocess />)} />
                <Route path="/vis/wordcloud" element={(<VisualizeWordcloud />)} />
                <Route path="/vis/wordcloud-detail" element={(<VisualizeWordcloudDetail />)} />
                <Route path="/vis/wordcloud-edit" element={(<VisualizeWordcloudEdit />)} />

                {/* <Route path="/vis/data" element={(<S3FileRequest />)} /> */}

                <Route path="/vis/wordfreq" element={(<VisualizeWordFrequency />)} />
                <Route path="/vis/wordfreq-detail" element={(<VisualizeWordFrequencyDetail />)} />

                <Route path="/vis/wordnetwork" element={(<VisualizeWordnetwork />)} />
                <Route path="/vis/wordnetwork-detail" element={(<VisualizeWordnetworkDetail />)} />

                {/* 보고서 작성 */}
                {/* <Route path="/report" element={(<Ecommerce />)} />

                {/*============기본 템픞릿============ */}
                {/* <Route path="/" element={(<Ecommerce />)} />
                <Route path="/ecommerce" element={(<Ecommerce />)} />

                <Route path="/orders" element={<Orders />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/customers" element={<Customers />} />

                <Route path="/kanban" element={<Kanban />} />
                <Route path="/editor" element={<Editor />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/color-picker" element={<ColorPicker />} />

                <Route path="/line" element={<Line />} />
                <Route path="/area" element={<Area />} />
                <Route path="/bar" element={<Bar />} />
                <Route path="/pie" element={<Pie />} />
                <Route path="/financial" element={<Financial />} />
                <Route path="/color-mapping" element={<ColorMapping />} />
                <Route path="/pyramid" element={<Pyramid />} />
                <Route path="/stacked" element={<Stacked />} /> */}

              </Routes>
            </div>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
